export default __webpack_public_path__ + "images/video-calling-step-2.a9aa544fd59d3fa6085743ff450b6dd9.png";